import styles from '../Styles/Benefits.module.css';
import Container from '../UI/Container';
import SectionTitle from '../UI/SectionTitle';

const Benefits = () => {
  const benefitsData = [
    {
      id: 1,
      title: 'Eficiencia y Confiabilidad',
      description: 'Infraestructura optimizada que reduce interferencias, minimiza fallos y mantiene tu operación activa sin interrupciones.',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
          <path d="M12 2L3 7v5c0 5.25 3.75 10.15 9 11.35C17.25 22.15 21 17.25 21 12V7L12 2z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
    },
    {
      id: 2,
      title: 'Soporte Técnico Especializado',
      description: 'Expertos con amplia experiencia en CCTV, redes, cableado y electricidad, listos para atenderte con rapidez.',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M6 20v-1a6 6 0 0112 0v1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          <path d="M18 8h2M20 8l-2 2M20 8l-2-2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
    },
    {
      id: 3,
      title: 'Ahorro a Largo Plazo',
      description: 'Soluciones que extienden la vida útil de tus equipos, reducen costos de reparación y eliminan tiempos de inactividad.',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M6 12H4M20 12h-2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      ),
    },
    {
      id: 4,
      title: 'Adaptado a Tu Negocio',
      description: 'Desde hogares hasta grandes empresas — diseñamos cada solución a la medida de tus necesidades reales.',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
          <rect x="3" y="3" width="8" height="8" rx="2" stroke="currentColor" strokeWidth="1.5"/>
          <rect x="13" y="3" width="8" height="8" rx="2" stroke="currentColor" strokeWidth="1.5"/>
          <rect x="3" y="13" width="8" height="8" rx="2" stroke="currentColor" strokeWidth="1.5"/>
          <rect x="13" y="13" width="8" height="8" rx="2" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
    },
  ];

  return (
    <section className={styles.benefits}>

      {/* ── Decorativos de fondo ── */}
      <div className={styles.orbTr} />
      <div className={styles.orbBl} />

      <Container>
        <SectionTitle
          title="¿Por qué elegirnos?"
          subtitle="Razones para confiar en FacSystem Col"
          highlight="elegirnos?"
          light={true}
        />
        <div className={styles.grid}>
          {benefitsData.map((benefit) => (
            <div key={benefit.id} className={styles.card}>
              <div className={styles.iconWrapper}>
                <span className={styles.iconCircle}>
                  {benefit.icon}
                </span>
              </div>
              <h3 className={styles.cardTitle}>{benefit.title}</h3>
              <p className={styles.cardDescription}>{benefit.description}</p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Benefits;